import { api } from '../utils/api.js';

export const stats = () => ({
  loading: false,
  error: null,
  successMessage: null,

  // Initialize component
  init() {
    console.log('Stats component initialized');
    this.clearMessages();
  },

  // Clear messages after timeout
  clearMessages() {
    setTimeout(() => {
      this.error = null;
      this.successMessage = null;
    }, 5000);
  },

  // Get player stat value
  getPlayerStat(statName) {
    const store = this.$store.app;
    const stats = store.player.stats || {};
    return stats[statName] || 1;
  },

  // Check if can allocate points to a stat
  canAllocate(statName, points) {
    const store = this.$store.app;
    const player = store.player;
    
    // Check if player has enough skill points
    if (!player.skillPoints || player.skillPoints < points) {
      return false;
    }

    // Check stat limit (10 per level)
    const currentStat = this.getPlayerStat(statName);
    const level = player.level || 1;
    const maxAllowed = level * 10;
    
    return (currentStat + points) <= maxAllowed;
  },

  // Allocate skill points to a stat
  async allocateStat(stat, points) {
    if (this.loading) return;
    
    const store = this.$store.app;
    
    // Validation
    if (!this.canAllocate(stat, points)) {
      this.error = `No puedes asignar ${points} puntos a ${stat}`;
      this.clearMessages();
      return;
    }

    this.loading = true;
    this.error = null;
    this.successMessage = null;

    try {
      const response = await api.post('/player/allocate', {
        stat,
        points
      });

      // Update player data in store
      store.updatePlayer(response.player);
      
      this.successMessage = response.message || `¡Asignaste ${points} puntos a ${stat}!`;
      
      // Show level up notification if applicable
      if (response.allocation) {
        const { stat: allocatedStat, newValue, pointsSpent } = response.allocation;
        store.addNotification(
          `⭐ ${allocatedStat} aumentó a ${newValue} (+${pointsSpent} puntos)`,
          'success'
        );
      }

      this.clearMessages();

    } catch (error) {
      console.error('Allocate stat error:', error);
      this.error = error.message || 'Error al asignar puntos de habilidad';
      this.clearMessages();
    } finally {
      this.loading = false;
    }
  },

  // XP Progression calculations (matching HUD)
  calculateXpForNextLevel(level) {
    return Math.floor(100 * Math.pow(level, 1.35));
  },

  calculateTotalXpForLevel(level) {
    let totalXp = 0;
    for (let i = 1; i < level; i++) {
      totalXp += Math.floor(100 * Math.pow(i, 1.35));
    }
    return totalXp;
  },

  getCurrentLevelXp() {
    const store = this.$store.app;
    const player = store.player;
    const totalXpForCurrentLevel = this.calculateTotalXpForLevel(player.level || 1);
    return (player.xp || 0) - totalXpForCurrentLevel;
  },

  getNextLevelXp() {
    const store = this.$store.app;
    const player = store.player;
    return this.calculateXpForNextLevel(player.level || 1);
  },

  getXpProgress() {
    const currentLevelXp = this.getCurrentLevelXp();
    const nextLevelXp = this.getNextLevelXp();
    if (nextLevelXp === 0) return 0;
    return Math.round((currentLevelXp / nextLevelXp) * 100);
  },

  // Format stat names for display
  getStatDisplayName(stat) {
    const names = {
      strength: 'Fuerza',
      agility: 'Agilidad', 
      intellect: 'Intelecto'
    };
    return names[stat] || stat;
  },

  // Get stat description/tooltip
  getStatDescription(stat) {
    const descriptions = {
      strength: 'Aumenta el daño en combate y la capacidad de carga',
      agility: 'Mejora la velocidad de viaje y la evasión en combate',
      intellect: 'Reduce el tiempo de misiones y mejora las recompensas'
    };
    return descriptions[stat] || '';
  }
});